/**
 * Map GetDemographics / patient payloads to a single-letter sex value for the portal UI and
 * `POST /Portal/UpdateDemographics` (`sex`, max length 1 in Swagger).
 */
export function normalizeSexFromApi(value: unknown): string {
  const raw = String(value ?? "").trim();
  if (!raw) return "";

  const upper = raw.toUpperCase();
  if (upper === "M" || upper === "MALE") return "M";
  if (upper === "F" || upper === "FEMALE") return "F";
  if (
    upper === "X" ||
    upper === "OTHER" ||
    upper === "NON-BINARY" ||
    upper === "NONBINARY" ||
    upper === "U" ||
    upper === "UNKNOWN"
  )
    return "X";
  if (upper.length === 1 && "MFX".includes(upper)) return upper;

  return "";
}
